var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDayClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "138px",
    height: "138px",
    viewBox: "0 0 138 138",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "day-clear") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "day-clear",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EFCC00",
    fillRule: "nonzero",
    cx: 67,
    cy: 67.4151931,
    r: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,0.415193115 L67,15.4151931",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,119.415193 L67,134.415193",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,67.4151931 L119,67.4151931",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,67.4151931 L0,67.4151931",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,19.4151931 L104,30.4151931",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,103.415193 L19,114.415193",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,114.415193 L104,103.415193",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30.4151931 L19,19.4151931",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayClear);
export default __webpack_public_path__ + "static/media/day-clear.8857a9c17ded7f694ed227635f2939fa.svg";
export { ForwardRef as ReactComponent };